import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import {
  ProgramTypesGUID,
  SpecialInvestmentPaymentScheduleTab,
  Milestone2PaymentBatchStatus
} from '../../../models/_enum-collections';
import { ApiResponse } from '../../../models/api-response.model';
import { CsiPaymentBatchMilestone2 } from '../../../models/csi-payment-batch-milestone2.model';
import { CsiPaymentScheduleActivitiesM2 } from '../../../models/csi-payment-schedule-activities-m2.model';
import { PaymentBatchStatusM2 } from '../../../models/payment-batch-status-m2.model';
import { AppConstants } from '../../common/app-constants';
import { CommonService } from '../../common/common.service';
import { SettingsService } from '../../common/settings.service';
import { CommonSharedModule } from '../../common/shared.module';
import { CSIPaymentScheduleService } from '../../services/csi-payment-schedule.service';

@Component({
  selector: 'app-csi-new-payment-batch-milestone2',
  templateUrl: './csi-new-payment-batch-milestone2.component.html',
  styleUrls: ['./csi-new-payment-batch-milestone2.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class CsiNewPaymentBatchMilestone2Component implements OnInit {
  program: ProgramTypesGUID = ProgramTypesGUID.MSSP;
  @ViewChild('dt', { static: false }) dt!: Table;

  engcols!: any[];
  apires!: ApiResponse;
  msgs: any[] = [];
  collecteIdArray: any[] = [];
  collecteId!: string;
  programTypeGuid: ProgramTypesGUID | any;
  selectedpaymentBatchStatusID: any;

  engagementList: CsiPaymentScheduleActivitiesM2[] = [];
  paymentBatchStatus: PaymentBatchStatusM2[] = [];
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;
  currentPageInfo!: string;
  totalRecords!: number;
  tblPageNumber!: number;
  paymentBatchForm!: FormGroup;
  createPaymentBatch!: CsiPaymentBatchMilestone2;
  selectedEngagements: CsiPaymentScheduleActivitiesM2[] = [];
  clonedEngs: Record<number, CsiPaymentScheduleActivitiesM2> = {};
  editing = false;
  editingNav = false;
  isSpin = false;
  showForm = true;
  disableSubmit = false;
  firstEditInitEng!: CsiPaymentScheduleActivitiesM2;
  editRowsCtr = 0;
  loading = false;
  loadingIcon = 'fa-circle-o-notch';

  constructor(
    private csiPaymentService: CSIPaymentScheduleService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    public settings: SettingsService,
    public router: Router
  ) {}

  ngOnInit() {
    this.loading = true;
    this.editing = false;
    this.dataViewRecsPerPage = 15;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.programTypeGuid = history.state.programTypeGuid;

    this.getPaymentBatchStatus();

    this.engcols = [
      { field: 'paymentLineItemId', header: 'Line Item Id' },
      { field: 'engagementId', header: 'Activity ID' },
      { field: 'engagementName', header: 'Activity Name' },
      { field: 'engagementSubType', header: 'Sub Type' },
      { field: 'partnerName', header: 'Partner Name' },
      { field: 'payeeID', header: 'Payee ID' },
      { field: 'milestone2EngagementType', header: 'Engagement Type' },
      { field: 'tier', header: 'Milestone 2 Tier' },
      { field: 'fundingAmount', header: 'Funding Amount' },
      { field: 'partnerLocation', header: 'Partner Location' },
      { field: 'fiscalYear', header: 'Fiscal Year' },
      { field: 'm2CategoryTypeValue', header: 'M2CategoryTypeValue ' },
      { field: 'paymentProfileStatus', header: 'ProfileStatus' },

      { field: 'partnerPriority', header: 'Partner Priority' },
      { field: 'blockedStatus', header: 'Blocked Status' },
      { field: 'sspaStatus', header: 'SSPA Status' },

      { field: 'partnerId', header: 'Partner ID' },
      { field: 'payeeName', header: 'Payee Name' },
      { field: 'contactName', header: 'Contact Name' },
      { field: 'contactEmail', header: 'Contact Email' },
      { field: 'emailLanguage', header: 'Email Language' },
      { field: 'accountCode', header: 'Account Code' },
      {
        field: 'internalOrderOrCostCenter',
        header: 'Internal Code or Cost Center'
      },
      { field: 'currency', header: 'Currency' },
      { field: 'amount', header: 'Amount' },
      { field: 'taxAmount', header: 'Tax Amount' },
      { field: 'msInvoiceNumber', header: 'MS Invoice Number' },
      { field: 'msInvoicePaidDate', header: 'MS Invoice Paid Date' },
      {
        field: 'paymentCentralTransactionID',
        header: 'Payment Central Transaction ID'
      }
    ];

    this.paymentBatchForm = this.formBuilder.group({
      paymentBatchScheduleDate: ['', [Validators.required]],
      anticipatedPaymentDate: ['', [Validators.required]],
      actualPaymentCentralDate: [''],
      paymentBatchStatus: ['', [Validators.required]],
      selectedEngs: [''],
      tier: [''],
      requestDetailId: [''],
      fundingAmount: [''],
      partnerId: [''],
      payeeName: [''],
      contactName: [''],
      contactEmail: [''],
      emailLanguage: [''],
      accountCode: [''],
      internalOrderOrCostCenter: [''],
      currency: [''],
      amount: [''],
      taxAmount: [''],
      msInvoiceNumber: [''],
      msInvoicePaidDate: [''],
      paymentCentralTransactionID: [''],
      milestoneengagementType: [''],
      m2CategoryTypeValue: [''],
      PaymentlineitemID: ['']
    });
    this.getEngagementDetials();
  }

  cancelSearchNav() {
    if (this.program !== null && this.program === ProgramTypesGUID.MSSP) {
      this.router.navigate(['events-payment-schedule'], {
        queryParams: { tab: SpecialInvestmentPaymentScheduleTab.Milestone2 },
        state: { programTypeGuid: this.program }
      });
    } else {
      this.router.navigate(['payment-schedule'], {
        queryParams: { tab: SpecialInvestmentPaymentScheduleTab.Milestone2 }
      });
    }
  }

  selectRow(e, l) {
    const engagement = this.engagementList.find(
      item => item.engagementId === l.engagementId
    );

    if (engagement) {
      engagement.editCheckBox = !engagement.editCheckBox;
    }
  }

  getEngagementDetials() {
    this.csiPaymentService
      .GetMilestone2PaymentScheduleActivities()
      .subscribe(engList => {
        this.engagementList = engList;
        if (this.engagementList != null) {
          this.totalRecords = this.engagementList.length;
        } else {
          this.totalRecords = 0;
        }

        if (this.totalRecords === 0) {
          this.currentPageInfo = 'No Record Found';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords > this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            1 * this.dataViewRecsPerPage +
            ' of ' +
            this.totalRecords +
            ' Records';
        }
        if (
          this.totalRecords > 0 &&
          this.totalRecords <= this.dataViewRecsPerPage
        ) {
          this.currentPageInfo =
            'Showing 1 - ' +
            this.totalRecords +
            ' of ' +
            this.totalRecords +
            ' Records';
        }

        this.loading = false;
      });
  }

  pageChange(e) {
    this.tblPageNumber = e.first;
    if (e.first + this.dataViewRecsPerPage > this.totalRecords) {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    } else {
      this.currentPageInfo =
        'Showing ' +
        (this.tblPageNumber + 1) +
        ' - ' +
        (this.tblPageNumber + this.dataViewRecsPerPage) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  getDateText(date: any): string {
    if (typeof date === 'string' && !date.startsWith('0001-01-01')) {
      date = new Date(date);
    }
    if (!(date instanceof Date) || isNaN(date.getTime())) {
      return 'Missing';
    }
    if (date.toISOString().startsWith('0001-01-01')) {
      return 'Missing';
    }
    return date.toDateString();
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    }
    if (this.totalRecords > 0 && this.totalRecords > this.dataViewRecsPerPage) {
      this.currentPageInfo =
        'Showing 1 - ' +
        1 * this.dataViewRecsPerPage +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
    if (
      this.totalRecords > 0 &&
      this.totalRecords <= this.dataViewRecsPerPage
    ) {
      this.currentPageInfo =
        'Showing 1 - ' +
        this.totalRecords +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  reset() {
    if (this.dt) {
      this.dt.sortField = 'engagementId';
      this.dt.sortOrder = -1;
      this.dt.reset();
    }
    if (this.engagementList === null || this.engagementList.length === 0) {
      this.totalRecords = 0;
      this.currentPageInfo = 'No Records Found';
    } else {
      this.totalRecords = this.engagementList.length;
      if (
        this.totalRecords > 0 &&
        this.totalRecords > this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          1 * this.dataViewRecsPerPage +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
      if (
        this.totalRecords > 0 &&
        this.totalRecords <= this.dataViewRecsPerPage
      ) {
        this.currentPageInfo =
          'Showing 1 - ' +
          this.totalRecords +
          ' of ' +
          this.totalRecords +
          ' Records';
      }
    }
  }
  getPaymentBatchStatus() {
    this.csiPaymentService
      .getMilestone2PaymentBatchStatus()
      .subscribe(engList => {
        this.paymentBatchStatus = engList;
      });
  }

  onSubmit() {
    this.loading = true;
    this.createPaymentBatch = {
      createdByUserAlias: this.settings.AliasName || '',
      paymentBatchScheduleDate:
        this.paymentBatchForm.controls['paymentBatchScheduleDate'].value,
      anticipatedPaymentDate:
        this.paymentBatchForm.controls['anticipatedPaymentDate'].value,
      actualPaymentCentralDate:
        this.paymentBatchForm.controls['actualPaymentCentralDate'].value,
      paymentBatchStatusId:
        this.paymentBatchForm.controls['paymentBatchStatus'].value.id,
      paymentBatchStatus:
        this.paymentBatchForm.controls['paymentBatchStatus'].value.name,
      PaymentBatchActivities: []
    };

    if (
      this.selectedEngagements.length !== 0 ||
      this.selectedEngagements.length !== undefined
    ) {
      for (const item of this.selectedEngagements) {
        this.createPaymentBatch.PaymentBatchActivities?.push({
          requestDetailId: item.engagementId?.toString(),
          engagementName: item.engagementName,
          engagementSubType: item.engagementSubType,
          tier: item.tier,
          fundingAmount: item.fundingAmount,
          partnerId: item.partnerId,
          payeeName: item.payeeName,
          contactName: item.contactName,
          contactEmail: item.contactEmail,
          emailLanguage: item.emailLanguage,
          accountCode: item.accountCode,
          internalOrderOrCostCenter: item.internalOrderOrCostCenter,
          currency: item.currency,
          amount: item.amount,
          taxAmount: item.taxAmount,
          msInvoiceNumber: item.msInvoiceNumber,
          msInvoiceDate: item.msInvoicePaidDate,
          paymentCentralTransactionID: item.paymentCentralTransactionID,
          payoutMatric: item.payoutMetric,
          engagementSubID: item.engagementSubID,
          paymentlineItemID: item.paymentLineItemId
        });
        const mn = this.engagementList.find(
          it => it.engagementId === item.engagementId
        );
        const msin = mn?.msInvoiceNumber;
        if (msin !== item.msInvoiceNumber) {
          this.collecteIdArray.push(mn?.engagementId);
        }
      }
    }
    if (
      this.selectedEngagements.length === 0 &&
      this.createPaymentBatch.paymentBatchStatusId !==
        Milestone2PaymentBatchStatus.Cancelled
    ) {
      this.loading = false;
      this.msgs = [];
      this.msgs.push({
        severity: 'error',
        detail: 'Please select any one Activity from the list'
      });
      setTimeout(() => {
        this.msgs = [];
      }, 5000);
      return;
    }
    this.createPaymentBatch.editids = this.selectedEngagements
      .filter(e => e.edited === true)
      .map(e => e.engagementId)
      .toString();
    this.createPaymentBatch.actualPaymentCentralDate =  this.createPaymentBatch.actualPaymentCentralDate
      ? this.createPaymentBatch.actualPaymentCentralDate
      : null;
    this.csiPaymentService
      .CreatePaymentBatchMilestone2(this.createPaymentBatch)
      .subscribe(
        messageResponse => {
          this.loading = false;
          this.apires = messageResponse;
          if (this.apires.success === true) {
            this.msgs = [];
            this.msgs.push({
              severity: 'success',
              detail: 'Payment Batch Created Successfully'
            });
            this.selectedEngagements = [];
            this.paymentBatchForm.reset();
            setTimeout(() => {
              if (
                this.program !== null &&
                this.program === ProgramTypesGUID.MSSP
              ) {
                this.router.navigate(['events-payment-schedule'], {
                  queryParams: {
                    tab: SpecialInvestmentPaymentScheduleTab.Milestone2
                  },
                  state: { programTypeGuid: this.program }
                });
              } else {
                this.router.navigate(['payment-schedule'], {
                  queryParams: {
                    tab: SpecialInvestmentPaymentScheduleTab.Milestone2
                  }
                });
              }
            }, 2000);
          } else if (this.apires.success === false) {
            this.loading = false;
            this.msgs = [];
            this.msgs.push({
              severity: 'error',
              detail: this.apires.errorMessages
                ? this.apires.errorMessages[0]
                : 'An error occurred'
            });
          }
          this.showForm = false;
        },
        error => {
          this.loading = false;
          this.msgs = [];
          let errors: string[] = [];
          if (error.status === 400) {
            errors = this.commonService.getBadRequestErrors(error);
            for (const msg of errors) {
              this.msgs.push({ severity: 'warn', detail: msg });
            }
          } else {
            this.msgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while Creating Payment Batch'
            });
          }
          this.showForm = true;
        }
      );
  }

  onRowEditInit(eng: CsiPaymentScheduleActivitiesM2) {
    this.clonedEngs[eng.engagementId || -1] = { ...eng };
    this.disableSubmit = true;
    if (this.editRowsCtr === 0) {
      this.editing = true;
      this.firstEditInitEng = Object.create(eng);
    }
    this.editRowsCtr++;
  }

  onRowEditSave(eng: CsiPaymentScheduleActivitiesM2) {
    if (eng.amount !== null) {
      delete this.clonedEngs[eng.engagementId || -1];
      this.disableSubmit = false;
      eng.edited = true;
      eng.partnerId = this.firstEditInitEng.partnerId;
      eng.payeeName = this.firstEditInitEng.payeeName;
      eng.contactName = this.firstEditInitEng.contactName;
      eng.contactEmail = this.firstEditInitEng.contactEmail;
      eng.emailLanguage = this.firstEditInitEng.emailLanguage;
      eng.accountCode = this.firstEditInitEng.accountCode;
      eng.internalOrderOrCostCenter =
        this.firstEditInitEng.internalOrderOrCostCenter;
      eng.currency = this.firstEditInitEng.currency;
      eng.amount = this.firstEditInitEng.amount;
      eng.taxAmount = this.firstEditInitEng.taxAmount;
      eng.msInvoiceNumber = this.firstEditInitEng.msInvoiceNumber;
      eng.msInvoicePaidDate = this.firstEditInitEng.msInvoicePaidDate;
      eng.paymentCentralTransactionID =
        this.firstEditInitEng.paymentCentralTransactionID;
    }
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editing = false;
    }
  }

  onRowEditCancel(eng: CsiPaymentScheduleActivitiesM2, index: number) {
    this.engagementList[index] = this.clonedEngs[eng.engagementId || -1];
    delete this.clonedEngs[eng.engagementId || -1];
    const idx = this.selectedEngagements.findIndex(
      e => e.engagementId === eng.engagementId
    );
    this.selectedEngagements.splice(idx, 1);
    this.engagementList[index].editCheckBox = false;
    this.disableSubmit = false;
    this.editRowsCtr--;
    if (this.editRowsCtr === 0) {
      this.editing = false;
    }
  }
}
